/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-07-18 09:53:09
 * @LastEditors: linxi
 * @LastEditTime: 2024-06-28 15:30:35
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Col, notification, Table } from 'antd'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { traceRoute } from '../../../layouts/layoutSlice'
import { ThemeContext } from '../../../theme/ThemeContext'
import { getJuhePage } from '../confirm/paymentConfirmSlice'
import { getPaymentListExoprt } from '../list/paymentSlice'
import { AGColumns, Columns } from './columns'
import { Query } from './Query'
import styles from './oweMoney.module.css'
import { RecipeStatus } from '../../../models/recipe'
import { selectTenantName, selectUserName } from '../../../app/applicationSlice'
import { printBody } from '../../../models/putstorelistPrint'
import { oweMonePagePrintBody } from '../../../models/oweMonePagePrint'
import { getGenderName } from '../../../models/user'
import { getAge } from '../../../utils/StringUtils'
import { getPayFlagName } from '../../../models/payment'
import { getPageColumnListAsync, getSubmitPageColumnListAsync } from '../../transactionQuery/transactionQuerySlice'
import SimpleAgGrid from '../../../compnents/simpleTable/SimpleAgGrid'
import { getSortColumnList } from '../../../models/common'

interface OweMonePageProps {
  status: number
  selectedTab: any
}
export const OweMonePage = ({ status, selectedTab }: OweMonePageProps): ReactElement => {
  const history = useHistory()

  const theme = useContext(ThemeContext)

  const tenantName = useSelector(selectTenantName)

  const userName = useSelector(selectUserName)

  const dispatch = useDispatch<RootDispatch>()

  const storageParams = JSON.parse(sessionStorage.getItem(location.pathname) || '{}')

  const [params, setParams] = useState<any>({
    current: 0,
    size: 10,
    arrearageFlg: 1,
  })

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  const [scrollHeight, setScrollHeight] = useState<any>()

  const [pageLoading, setPageLoading] = useState(false)

  const [exportLoading, setExportLoading] = useState(false)

  // 所有的列表
  const listData: any = [
    {
      headerName: '序号',
      width: 80,
      minWidth: 80,
      field: 'index',
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '门诊号',
      field: 'outpatientNo',
      width: 90,
      minWidth: 90,
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '患者姓名',
      field: 'patientName',
      width: 120,
      minWidth: 120,
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '病历号',
      field: 'patientId',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '性别',
      field: 'patientSex',
      minWidth: 80,
      visible: true,
    },
    {
      headerName: '年龄',
      field: 'patientAge',
      minWidth: 80,
      visible: true,
    },
    {
      headerName: '结算险种',
      field: 'insuranceCode',
      minWidth: 100,
      visible: true,
    },

    {
      headerName: '收费标志',
      field: 'settlementCategory',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '诊断疾病',
      field: 'disease',
      minWidth: 140,
      visible: true,
    },
    {
      headerName: '接诊科室',
      field: 'treatmentDepartmentName',
      minWidth: 130,
      visible: true,
    },
    {
      headerName: '接诊医生',
      field: 'treatmentDoctorName',
      minWidth: 160,
      visible: true,
    },
    {
      headerName: '欠费状态',
      field: 'accountingStatus',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '挂号时间',
      field: 'registrationTime',
      minWidth: 150,
      visible: true,
    },
    {
      headerName: '欠费金额',
      field: 'arrearageAmount',
      align: 'center',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '最近补交时间',
      field: 'lastPayTime',
      minWidth: 150,
      visible: true,
    },
    {
      headerName: '操作',
      field: 'action',
      width: 160,
      minWidth: 160,
      pinned: 'right',
      lockPosition: "right",
      suppressMovable: true,
      visible: true,
    },
  ]?.map((v, index) => {
    return {
      ...v,
      index: index + 1,
    }
  })

  const allData = listData 

  // 默认要展示的列的值
  const selectColumns = allData?.filter((v: any) => v.visible)?.map((item: any) => item.field) || []

  const [allColumnList, setAllColumnList] = useState<any[]>([]) //筛选列所有的数据

  // 筛选列所有的数据
  const [filterColumnList, setFilterColumnList] = useState<any[]>([])

  const [filterSelectList, setFilterSelectList] = useState<any[]>([]) //筛选列所有的数据
  
  useEffect(() => {
    //缓存状态
    params.current &&
      sessionStorage.setItem(
        location.pathname,
        JSON.stringify({ ...params, state: status, arrearageFlg: undefined })
      )
  }, [params, status])

  const getPage = () => {
    //欠费管理列表
    setPageLoading(true)
    dispatch(getJuhePage(params))
      .then(unwrapResult)
      .then((res) => {
        // onResize() // 初始化设置高度
        // window.addEventListener('resize', onResize)
        const data = {
          total: res.total,
          items: res.records,
        }
        setPage(data)
        if (params.param?.length == 9 && res.records.length == 1) {
          //病历号跳转
          setParams({ ...params, param: '' })
          setTimeout(() => {
            history.push(
              `/payment/oweMoney?paymentId=${res.records[0]?.paymentId}`
            )
          }, 100)
        }
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  useEffect(() => {
    if (selectedTab == '5') {
      if (params.current != 0 && params?.registrationTimeHead) {
        getPage()
        getPageColumnList()
      }
    }
  }, [params, selectedTab])

  useEffect(() => {
    if (selectedTab == '5') {
      setAllColumnList(allData)
    }
  }, [selectedTab])

  const submitPageList = (data: any) => {
    const params = {
      pageName: 'oweMonePage',
      configJson: JSON.stringify(data),
    }
    dispatch(getSubmitPageColumnListAsync({
      ...params,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        getPageColumnList(v?.id)
      })
  }

  const getPageColumnList = (id?: any) => {
    dispatch(getPageColumnListAsync({
      id: id ? id : undefined,
      pageName: 'oweMonePage',
    }))
      .then(unwrapResult)
      .then((v: any) => {
        const data: any = v?.configJson ? JSON.parse(v?.configJson) : []
        const filterList = data?.filter((n: any) => n?.visible)
        const columns = filterList?.map((n: any) => n?.field)
        const sameFileds = allData?.find((item: any) => item?.field == v?.field)
        const resetData = data?.map((v: any) => ({
          ...v,
          minWidth: sameFileds?.minWidth || v?.minWidth,
          width: sameFileds?.width || v?.width,
          headerName: sameFileds?.headerName || v?.headerName,
        }))
        // 所有的数据
        setAllColumnList(data?.length ? resetData : allData)
        // 筛选后存在后端的数据
        setFilterColumnList(filterList?.length ? filterList : allData)
        // 选中的值
        setFilterSelectList(columns?.length ? columns : selectColumns)
      })
      .catch(() => {
        setAllColumnList(allData)
        setFilterColumnList(allData)
        setFilterSelectList(selectColumns)
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  }

  const outCluedExport = () => {
    setExportLoading(true)
    dispatch(
      getPaymentListExoprt({ ...params, size: undefined, arrearageFlg: 1 })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '欠费管理.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        return
      })
      .finally(() => {
        setExportLoading(false)
      })
  }

  const onResize = () => {
    const table = document.getElementById(
      status == RecipeStatus.oweMone ? 'tableHeightOweMonePage' : ''
    )
    if (table) {
      const height = table.offsetHeight - 60 - 80 - 20
      setScrollHeight(height)
    } else {
      return '100%'
    }
  }

  const dataMainList = {
    tenantName: tenantName,
    userName: userName,
    dataList: page.items?.map((v: any) => {
      return {
        ...v,
        outpatientNo: v?.registration.outpatientNo,
        patientName: v?.treatment.patientName,
        patientId: v?.registration.patientId,
        patientSex: getGenderName(v?.treatment.patientSex),
        patientAge: getAge(
          v?.treatment?.patientAge,
          v?.treatment?.patientMonth
        ),
        insuranceCode:
          v?.registration.insuranceCode === 'ZIFEI' ||
          !v?.registration.insuranceCode
            ? '自费'
            : '智慧医保',
        settlementCategory: getPayFlagName(v?.treatment.settlementCategory),
        disease: v?.treatment?.disease,
        treatmentDepartmentName: v?.treatment.treatmentDepartmentName,
        treatmentDoctorName: v?.treatment.treatmentDoctorName,
        accountingStatus: v?.accountingStatus === 0 ? '已结清' : '欠费中',
        registrationTime: v.registration.registrationTime,
        arrearageAmount:
          v?.arrearageAmount === undefined
            ? ''
            : v?.arrearageAmount?.toFixed(2),
        lastPayTime: v?.treatment.lastPayTime,
      }
    }),
  }

  const content = oweMonePagePrintBody(dataMainList)

  return (
    <Col
      style={{
        backgroundColor: theme.pn,
        borderRadius: 10,
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100% - 10px)',
        marginTop: '10px',
        overflow: 'hidden',
        padding: '10px 15px 0 15px',
      }}
    >
      <Query
        loading={pageLoading}
        exportLoading={exportLoading}
        outExportExcel={() => {
          outCluedExport()
        }}
        print={() => {
          const page: any = window?.open('', '_blank') // 打开一个新窗口，用于打印
          page?.document?.write(content) // 写入打印页面的内容
          page?.print() // 打印
          page?.close()
        }}
        status={status}
        onValueChange={(v) => setParams({ ...params, ...v })}
        filterColumn={allColumnList} //筛选列
        filterSelectList={filterSelectList}
        // 筛选列变化时的数据
        submitPageList={(v: any) => {
          setPageLoading(true)
          submitPageList(v)
            setAllColumnList(v)
          }}
      />
      <div
        id={status == RecipeStatus.oweMone ? 'tableHeightOweMonePage' : ''}
        style={{
          width: '100%',
          height: '100%',
        }}
      >
        <SimpleAgGrid
          page={{
            current: params?.current || 1,
            size: params?.size || 10,
            total: page?.total,
            items: page?.items,
          }}
          column={AGColumns(
            params.size * (params.current - 1),
            (action, t) => {
              if (action == 'detail') {
                dispatch(
                  traceRoute({
                    name: '收费',
                    path: '/payment/result',
                    query: `paymentId=${t.paymentId}&&status=${status}`,
                    state: {
                      name: '欠费管理',
                      path: '/payment',
                      routeName: '欠费管理',
                    },
                  })
                )
              } else if (action == 'supplementary') {
                history.push(`/payment/oweMoney?paymentId=${t.paymentId}`)
                // dispatch(
                //   traceRoute({
                //     name: '补交',
                //     path: '/payment/oweMoney',
                //     query: `paymentId=${t.paymentId}`,
                //   })
                // )
              }
            }, allColumnList
          )?.filter((item: any) => filterSelectList?.includes(item.field))}
          isLoading={pageLoading}
          pagination={true}
          pageKey={'oweMonePage'}
          pinnedBottomRowData={[{
            arrearageAmount: page?.items?.[0]?.amountInArrears?.toFixed(2) || '0.00' || '',
             // 剩余没有合计行的列展示为空
          }]}
          getRowStyle={(params) => {
            if (params.node.rowPinned) {
              return {
                fontWeight: 'normal',
                backgroundColor: '#D9F2FF',
              };
            }
            return {}; // 将返回 null 改为返回空对象，避免类型不匹配问题
          }}
          onChangePage={(current, size) =>
            setParams({
              ...params,
              current,
              size: size || 10,
            })
          }
          onColumnMoved={(v) => {
            // setPageLoading(true)
            const sortList = getSortColumnList(allColumnList, v);
            submitPageList(sortList)
            setAllColumnList(sortList)
            console.log("sortList", allColumnList, sortList)
          }}
        />
      </div>
    </Col>
  )
}
